<h2 mat-dialog-title>Zarządzaj kosztem - {{ cost.name }}</h2>

<mat-dialog-content class="pt-3">
	@if (isLoadingPrices() || isSaving()) {
		<div class="d-flex justify-content-center align-items-center h-400">
			<mat-spinner></mat-spinner>
		</div>
	} @else {
		<div class="costs-dialog-body d-flex flex-column overflow-hidden">
			<div class="costs-ranges-scroll overflow-auto flex-grow-1">
				<div class="d-flex flex-column gap-3 min-width-0 mt-2">
					@for (priceGroup of pricesFormArrayControls(); track priceGroup.controls.rowId.value) {
						<div class="d-flex align-items-start gap-3 flex-wrap" [formGroup]="priceGroup">
							<mat-form-field appearance="outline" class="costs-date-range-field">
								<mat-label>Zakres dat</mat-label>
								<mat-date-range-input [rangePicker]="picker">
									<input matStartDate formControlName="start" placeholder="Od" />
									<input matEndDate formControlName="end" placeholder="Do" />
								</mat-date-range-input>
								<mat-hint>DD.MM.RRRR – DD.MM.RRRR</mat-hint>
								<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
								<mat-date-range-picker #picker></mat-date-range-picker>

								@if (
									(priceGroup.controls.start.hasError('required') &&
										priceGroup.controls.start.touched) ||
									(priceGroup.controls.end.hasError('required') && priceGroup.controls.end.touched)
								) {
									<mat-error>To pole jest wymagane</mat-error>
								}

								@if (
									(priceGroup.controls.start.hasError('dateRangesOverlap') &&
										(priceGroup.controls.start.touched || priceGroup.controls.start.dirty)) ||
									(priceGroup.controls.end.hasError('dateRangesOverlap') &&
										(priceGroup.controls.end.touched || priceGroup.controls.end.dirty))
								) {
									<mat-error>Zakresy dat nachodzą na siebie</mat-error>
								}
							</mat-form-field>

							<mat-form-field appearance="outline" class="costs-price-field">
								<mat-label>Cena</mat-label>
								<input matInput type="number" formControlName="price" />
								@if (
									priceGroup.controls.price.hasError('required') && priceGroup.controls.price.touched
								) {
									<mat-error>To pole jest wymagane</mat-error>
								}
							</mat-form-field>

							<button
								mat-icon-button
								aria-label="Usuń zakres"
								type="button"
								color="warn"
								(click)="removePrice($index)"
							>
								<i class="fas fa-trash"></i>
							</button>
						</div>
					}
				</div>
			</div>

			<div class="flex-shrink-0 d-flex flex-column gap-3 mt-2">
				@if (dateRangeGaps().length > 0) {
					<div class="alert alert-warning d-flex align-items-start gap-2 mb-0" role="alert">
						<i class="fas fa-exclamation-triangle mt-1"></i>
						<div>
							<div class="fw-semibold">Wykryto przerwy między zakresami dat:</div>
							<ul class="mb-1 mt-1 ps-3">
								@for (gap of dateRangeGaps(); track $index) {
									<li>
										{{ formatGapDate(gap.endOfFirst) }} → {{ formatGapDate(gap.startOfSecond) }} ({{
											gap.gapDays
										}}
										{{ gap.gapDays === 1 ? 'dzień' : 'dni' }} przerwy)
									</li>
								}
							</ul>
							<div class="small">Może to spowodować brak ceny w tym okresie.</div>
						</div>
					</div>
				}

				<button mat-stroked-button type="button" (click)="addPrice()">
					<i class="fas fa-plus me-1"></i>
					Dodaj zakres
				</button>
			</div>
		</div>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button (click)="cancel()" [disabled]="isSaving()">Anuluj</button>
	@let saveBtnDisabled = isSaving() || pricesFormArray.invalid || pricesFormArray.length === 0;
	@if (dateRangeGaps().length > 0) {
		<button mat-raised-button color="primary" (click)="save(true)" [disabled]="saveBtnDisabled">
			@if (isSaving()) {
				<mat-spinner diameter="20" class="me-1"></mat-spinner>
			}
			Zapisz mimo to
		</button>
	} @else {
		<button mat-raised-button color="primary" (click)="save()" [disabled]="saveBtnDisabled">
			@if (isSaving()) {
				<mat-spinner diameter="20" class="me-1"></mat-spinner>
			}
			Zapisz
		</button>
	}
</mat-dialog-actions>
